import type { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { useMicroNgConfig } from '@eliboo/micro-ng/core';

import { MICRO_API_CONTEXT } from './context';

export const microApiInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const context = req.context.get(MICRO_API_CONTEXT);
  const isMicroApi = !!context;
  if (!isMicroApi) return next(req);
  const { injector, hostUrl, appId, urlTransform } = context;
  const configs = useMicroNgConfig(injector);
  if (appId !== configs.appId) return next(req);
  
  function getHttpFullUrl(url: string) {
    const assets = {
      realPrefix: 'assets',
      usePrefix: '@assets',
    };

    let newUrl: string | undefined;
    if (assets) {
      const { realPrefix, usePrefix } = assets;
      if (url.startsWith(realPrefix)) {
        newUrl = url;
      } else if (usePrefix && url.startsWith(usePrefix)) {
        url = url.replace(usePrefix, realPrefix);
        newUrl = url;
      }
    }

    if (newUrl) return newUrl;

    if (!url.startsWith('https://') && !url.startsWith('http://')) {
      if (urlTransform) {
        url = urlTransform(url, injector);
      }
      const host = typeof hostUrl === 'string' ? hostUrl : hostUrl(req, injector);
      newUrl = host + (url.startsWith('/') && host.endsWith('/') ? url.substring(1) : url);
      console.log('newUrl', newUrl, host);
    }

    return newUrl || url;
  }
  // 处理url
  const newUrl = getHttpFullUrl(req.url);

  const headers = req.headers;
  const newReq = req.clone({
    url: newUrl,
    headers: headers,
  });
  return next(newReq);
};
